import { CourseProgressState } from "../course-details/course-progress.enum";

export const isExamUnlockedOrCourseCompleted = (state?: CourseProgressState) =>
  [
    CourseProgressState.FINISHEDWATCHING,
    CourseProgressState.COMPLETED,
  ].includes(state ?? CourseProgressState.NOTSTARTED);
